import Tooltip from '@mui/material/Tooltip';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

import styles from './WarningTooltip.module.css';

const WarningTooltip = ({
  children,
  message,
  placement = 'bottom',
  maxWidth = '400px',
  iconColor = '#f48924',
  disabled = false,
  slotProps,
  ...props
}) => {
  const shouldDisableTooltip = disabled || !message;
  const popperModifiers = [
    {
      name: 'preventOverflow',
      options: {
        padding: 16,
      },
    },
    ...(slotProps?.popper?.modifiers || []),
  ];

  return (
    <Tooltip
      title={
        shouldDisableTooltip ? (
          ''
        ) : (
          <span className={styles.content}>
            <WarningAmberRoundedIcon className={styles.icon} sx={{ color: iconColor }} />
            <span className={styles.message}>{message}</span>
          </span>
        )
      }
      placement={placement}
      arrow
      slotProps={{
        ...slotProps,
        popper: {
          ...slotProps?.popper,
          modifiers: popperModifiers,
        },
        tooltip: {
          ...slotProps?.tooltip,
          sx: {
            maxWidth,
            ...(slotProps?.tooltip?.sx || {}),
          },
        },
      }}
      disableFocusListener={shouldDisableTooltip}
      disableHoverListener={shouldDisableTooltip}
      disableTouchListener={shouldDisableTooltip}
      {...props}
    >
      {children}
    </Tooltip>
  );
};

export default WarningTooltip;
